import { render, staticRenderFns } from "./SithMesAgreementList.vue?vue&type=template&id=1b80307d&"
import script from "./SithMesAgreementList.vue?vue&type=script&lang=js&"
export * from "./SithMesAgreementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports